<template>
  <div class="cx-row--nogutter">
    <template v-for="item in experienceMenu">
      <nav class="cx-col-md-4" :key="item.category">
        <div class="cx-t01 m-collapse__header">
          <router-link-localed :to="`/${item.category}`"
          >{{item.name}}</router-link-localed>
        </div>
        <!-- Most View Sight -->
        <router-link-localed v-if="item.topViewSight"
          class="cx-div m-collapse__flat"
          @click.native="() => $gtmSet('vpopular', true)"
          :to="`/${item.category}/${item.topViewSight.group}/${item.topViewSight.id}`"
        >
          <div class="cx-row--flat">
            <div class="cx-col">
              <div class="cx-media m-collapse__thumb">
                <cx-img
                  alt=""
                  :imgSrc="getMediaHost(item.topViewSight.thumbnail, 'MGTO_MEDIA')"
                  class="-round-corner"
                ></cx-img>
              </div>
            </div>
            <div class="cx-col m-collapse__flex">
              <div class="m-collapse__wrapper">
                <div class="cx-t01 m-collapse__subtitle">
                  {{$t('header.mostViewed')}}
                </div>
                <div class="cx-t20 m-collapse__title">
                  {{item.topViewSight.name}}
                </div>
              </div>
            </div>
          </div>
        </router-link-localed>
        <div class="cx-row--flat" v-else>
          <div class="cx-col">
            <div class="cx-media m-collapse__thumb">
              <div class="cx-media__img cx-media__img--round-corner"></div>
            </div>
          </div>
          <div class="cx-col m-collapse__flex">
            <div class="m-collapse__wrapper">
              <div class="cx-t01 m-collapse__subtitle">
                {{$t('header.mostViewed')}}
              </div>
              <div class="cx-t20 m-collapse__title">
                <content-placeholders 
                  style="padding-top: 1rem;" 
                  :animated="false"
                  rounded >
                  <content-placeholders-text :lines="1"/>
                </content-placeholders>
              </div>
            </div>
          </div>
        </div>
        <!-- Groups -->
        <router-link-localed 
          v-for="g in item.groups"  
          :key="g.group"
          class="m-collapse__link"
          :to="`/${item.category}/${g.group}`"
        >
          <i class="fas fa-angle-right"></i>
          {{g.name}}
        </router-link-localed>
      </nav>
    </template>
    <cx-img 
      tag="div"
      class="m-collapse__graphic m-collapse__experience m-graphic--experience"
      imgSrc="/static/graphic/mgto_graphic_menu_experience.png"
      :imgHolder="false"
    ></cx-img>
  </div>
</template>

<script>

export default {
  name: 'main-header-collapse-experience',
  uit() {
    return [
      ['header', ['mostViewed']],
    ]
  },
  props: {
    experienceMenu: {
      type: Array,
      default: () => [],
    }
  },
}
</script>
